import * as libRegions from '@luxuryescapes/lib-regions';

export default (currencyCode) => {
  return libRegions.getRegions().find((region) => region.currencyCode === currencyCode);
};
